export const endpoint = {
	auth: {
		LOGIN: '/api/auth/token',
		LOGOUT: '/api/user/logout',
		TOKEN_CODE: '/api/user/token/code',
		CONNECT: '/api2/auth/open-id/connect',
		CFG: '/api/auth/cfg',
		PASSWORD_POLICY: '/api/auth/password/policy',
		REFRESH_TOKEN: '/api2/auth/refresh/token',
	},
	user: {
		ORGANIZATIONS: '/organizations',
		USER_INFO: '/api/user',
		GET_NEW_MESSAGE_COUNT: '/api/get_new_message_count',
		FETCH_MESSAGES: '/api/fetch_messages',
		MARK_AS_READ_MESSAGE: (messageId: number) => `/api/mark_as_read_message/${messageId}`,
		DELETE_MESSAGE: (messageId: number) => `/api/delete_message/${messageId}`,
		SET_TIMEZONE: '/api/em/timezone',
		SET_PRODUCT_LANGUAGE: '/api/em/product_language',
		SET_SALE_OVER_THRESHOLD: '/api/em/sale_over_threshold',
		CONFIG: '/api/configs',
		EM_ASSIGNMENT: '/api/em_assignment',
		CONTRACT_DOCUMENTS: '/api/contract_documents',
		GET_DOWNLOADED_DOCUMENTS: '/api/getDownloadedDocuments',
		FETCH_PREVIOUS_CONTRACT_DOCUMENT: '/api/fetch_previous_contract_document',
		FETCH_CONTRACT_DOCUMENT: '/api/fetch_contract_document',
		FETCH_USERS: '/api/user/fetch_users',
		UPDATE_USER: '/api/user/update_user',
		DELETE_USER: (userId: string) => `/api/user/delete_user/${userId}`,
		CREATE_USER: '/api/user/create_user',
		UPDATE_NOTIFICATION_SUBSCRIPTION: '/api/update_notification_subscription',
		FETCH_NOTIFICATION_SUBSCRIPTIONS: (userId: string) =>
			`/api/fetch_notification_subscriptions/${userId}`,
		CREDENTIALS_RESET: '/api2/auth/user/credentials/reset',
		TWO_FA_STATUS: '/api2/auth/open-id/2fa/status',
		TWO_FA_ENABLE: '/api2/auth/open-id/2fa/enable',
		TWO_FA_DISABLE: '/api2/auth/open-id/2fa/disable',
		SPECIAL_SCHEMES: '/api2/user/special_schemes',
		INTEGRATIONS: '/api2/integrations',
		NEW_WIX_INTEGRATION: '/api2/integrations/wix',
		UPLOADED_SALES_REPORTS: '/api2/em_sales_reports/uploaded_files',
		UPLOAD_SALES_REPORT: '/api2/em_sales_reports/upload_file',
		DOWNLOAD_SALES_REPORT: (fileId: number) => `/api2/em_sales_reports/download_file/${fileId}`,
	},
	shops: {
		SHOPS: '/api/shops',
		SHOP_GOODS: `/api/products/query`,
		ADD_SHOP: '/api/shops/woo',
		DELETE_SHOP: (shopId: number) => `/api/shops/${shopId}`,
		SHOP_ATTRIBUTES_FORM: (shopId: number) => `/api/shops/${shopId}/attributes/form`,
		SHOP_ATTRIBUTES: (shopId: number) => `/api/shops/${shopId}/attributes`,
		SHOP_MIGRATE: (shopId: number) => `/api/shops/${shopId}/migrate`,
		SHOP_MIGRATION_STATUS: (shopId: number) => `/api/shops/${shopId}/migration_status`,
		SHOP_MIGRATION_RESTART: (shopId: number) => `/api/shops/${shopId}/migration/restart`,
	},
	hscodes: {
		HS_CODES: '/api/hscodes',
		HS_CODES_BY_ID: (id: number) => `/api/hscodes/${id}`,
	},
	goods: {
		UPDATE_GOODS: '/api/products',
		DELETE_GOODS: '/api/products',
	},
	classifications: {
		JOBS: 'api/hscodes/classification/jobs',
	},
};
